<template>

<v-form v-model="valid">
  <v-container>

    <v-app-bar
      app
      color="grey lighten-4"
    >

     <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>


          <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://conciergepad-images.s3.amazonaws.com/concierge_logo.png"
          transition="scale-transition"
          width="250"
        />
        </div>

    
         </v-app-bar>


<v-navigation-drawer
        v-model="drawer"
        :color="color"
        :expand-on-hover="expandOnHover"
        :mini-variant="miniVariant"
        :right="right"
        :permanent="permanent"
        :src="bg"
        absolute
        temporary
        dark
      >
        <v-list
          dense
          nav
          class="py-0"
        >
          <v-list-item two-line :class="miniVariant && 'px-0'">

            <v-list-item-content>
              <v-list-item-title>Menu</v-list-item-title>
              <v-list-item-subtitle>Please select link from sidebar</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item
            v-for="item in itemsDrawer"
            :key="item.title"
            link
            @click="$router.push({ path: item.route })"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>



<v-banner single-line>
    <v-icon
      slot="icon"
      color="warning"
      size="36"
    >
      mdi-shield-account
    </v-icon>
    User Signed-In
    <template v-slot:actions>
      
        {{username}}
     
    </template>
  </v-banner>



   
       

    

    

 

<v-divider></v-divider>


  <v-toolbar
    dark
    color="deep-purple accent-4"
  >
    <v-toolbar-title>Search</v-toolbar-title>
    <v-autocomplete
        v-model="studentSearchSelected"
        :items="studentsAllArray"
        item-text="name"
        item-value="studentId"
        label="Look up Student"
         class="mx-4"
       flat
      hide-no-data
      hide-details
      solo-inverted
      >
    </v-autocomplete>
    <v-progress-linear v-if="loaded"
      indeterminate
      color="yellow darken-2"
    ></v-progress-linear>
 <v-btn icon  v-on:click="StudentProfileAlert()">
      <v-icon>mdi-magnify</v-icon>
    </v-btn>
     <v-btn icon  v-on:click="clearDataTable()">
      <v-icon>mdi-close</v-icon>
    </v-btn>

    
  </v-toolbar>
  <v-toolbar
    dark
    color="deep-purple accent-4"
    v-if="hasData"
  >

       <v-select 
          v-model="demeritCodeSelectedSearch"
          :items="demeritCodes"
          item-text="desc"
          item-value="code"
          label="Filter By Demerit Code"
          return-object
          v-on:change="GetStudentProfileDemerit(demeritCodeSelectedSearch.code)"
     
        ></v-select>

 </v-toolbar>
<v-data-table
    v-model="selected"
    :headers="headers"
    :items="students"
    :single-select="singleSelect"
    item-key="studenT_ID"
    class="elevation-1"
    @click:row="rowClick"
  >


    <template v-slot:item.entrY_TIME="{ item }">
      {{ formatDate(item.entrY_TIME) }}
    </template>

    <template v-slot:item.demeriT_DATE ="{ item }">
      {{ simpleDate(item.demeriT_DATE) }}
    </template>

  <template v-slot:item.id="{ item }">

      
      <!--<v-btn color="error" v-on:click='removeStudent(item.id,item.studenT_ID,item.firsT_NAME,item.lasT_NAME,item.entrY_TIME,item.schooL_TYPE,item.demeriT_CODE,item.comments,item.companY_NAME,item.entrY_DATE,item.demeriT_DESC,item.username,"Y",item.scaN_METHOD,item.durinG_PERIOD,item.triggeR_LINK)'>Remove</v-btn>-->
 

  <v-icon
        class="mr-2"
        v-on:click='createPDF(item.demeriT_DESC,item.studenT_ID,item.lasT_NAME,item.firsT_NAME,item.durinG_PERIOD,formatDate(item.entrY_TIME),item.username,item.comments,item.prinT_LABEL)'
      >
        mdi-printer
      </v-icon>
      <v-icon
       v-on:click='removeStudent(item.id,item.studenT_ID,item.firsT_NAME,item.lasT_NAME,item.entrY_TIME,item.schooL_TYPE,item.demeriT_CODE,item.comments,item.companY_NAME,item.entrY_DATE,item.demeriT_DESC,item.username,"Y",item.scaN_METHOD,item.durinG_PERIOD,item.triggeR_LINK)'
      >
        mdi-delete
      </v-icon>

 
  </template>




    
  </v-data-table>


<v-divider></v-divider>

 <v-timeline
    align-top
    :dense="$vuetify.breakpoint.smAndDown"
  >
    <v-timeline-item
      v-for="(item, i) in students"
      :key="i"
      color="red lighten-2"
      large
      fill-dot
    >


        <template v-slot:opposite>
        <span
          v-text="simpleDate(item.entrY_DATE)"
        ></span>
      </template>
      <v-card class="elevation-2">
        <v-card-title class="headline">
          <span 
          v-text="item.demeriT_DESC"
        ></span>
        </v-card-title>
        <v-card-text>
          {{item.demeriT_CODE}} -  {{item.firsT_NAME}} {{item.lasT_NAME}} Entry Date: {{ simpleDate(item.entrY_TIME) }}
          <v-divider></v-divider>
           {{item.prinT_LABEL}}
        </v-card-text>
      </v-card>

     
    </v-timeline-item>
    
  </v-timeline>


    


    </v-container>
  </v-form>


</template>


<script>

  import axios from 'axios';
  import store from '../store';
  import { uuid } from 'vue-uuid';
  import moment from 'moment-timezone';
  import jsPDF from 'jspdf'

  export default {
    components: { },
    data: () => ({

      drawer: false,
        itemsDrawer: [
          { title: 'Student Management', icon: 'mdi-account-school', route:'TrackingDetail' },
          { title: 'Student Serach', icon: 'mdi-magnify', route:'#' },
          { title: 'Logout', icon: 'mdi-logout', route:'tracking' },
        ],
        color: 'deep-purple accent-4v',
        colors: [
          'primary',
          'blue',
          'success',
          'red',
          'teal',
        ],
        right: false,
        clipped: true,
        permanent: false,
        miniVariant: false,
        expandOnHover: false,
        background: false,
        singleSelect: true,
        selected: [],
        hasData: false,
        headers: [
          {
            text: 'Student ID',
            align: 'start',
            sortable: false,
            value: 'studenT_ID',
          },
          { text: 'First', value: 'firsT_NAME' },
          { text: 'Last', value: 'lasT_NAME' },
          { text: 'Period', value: 'durinG_PERIOD' },
          { text: 'Code', value: 'demeriT_CODE' },
          { text: 'Desc', value: 'demeriT_DESC' },
          { text: 'Detail', value: 'prinT_LABEL' },
          { text: 'Time', value: 'entrY_TIME' },
          { text: 'User', value: 'username' },
          { text: 'Note', value: 'comments' },
          { text: ' ', value: 'id' },
        ],
         isEditing: false,
        model: null,
        uuid: uuid.v1(),
        studentsAllArray: [],
        studentsAllArrayTemp: [],
        states: [
         {name: 'Rene Perez', studentId: '1234'},
         {name: 'Juan Jugo', studentId: '456'},
         {name: 'Pepito Perez', studentId: '843'},
        ],
        entryDate: moment(new Date()).format("YYYY-MM-DD"),
        ampmintitle: true,
      menu: false,
      modal: false,
      menu2: false,
      entryTime: null,
      entryTimeDisplay: moment(new Date()).format("hh:mm A"),
    studentExists: true,
    studentId:'',
    studentIdSelected: '',
    studentSearchSelected: '',
    generalValue: 'N',
    studentDob: '',
    demeritCodes:  [],
    demeritCodeArray: [],
    duringPeriodTemp: [],
    duringPeriod: ['1','2'],
    validStudent: false,
    invalidStudent: false,
    guardianFirstName: '',
    commentsCount: 0,
    studentsAttached: [],
    guardianLastName: '',
    guardianRelation: '',
    guardianEmail: '',
    guardianPhone: '',
    loginUuid:'',
    validUpdate: false,
    invalidUpdate: false,
    validEmailGuardian: false,
    invalidEmailGuardian: false,
    alreadyRegistered: '',
    studentArray: [],
    addStudentArray: '',
    hangerIdArray: [],
      passwordAlert: false,
      message: '',
      alert: false,
      loaded: false,
      results: {},
      firstName: '',
      _isMounted:false,
      connectArray: [],
      pId: '',
      compName: '',
      hagnerId: '',
      jwsToken: '',
      username: '',
      password: '',
      demeritCode: '',
      schoolType: '',
      duringPeriodSelected: '',
      demeritCodeSelected: '',
      demeritCodeSelectedSearch: '',
      comments: '',
      scanMethod: '',
      reTypePassword: '',
      valid: true,
      validCode: false,
      invalidCode: false,
      doAdd: "N",
      items: {},
      students: [],
      name: '',
      accessToken: '',
      nameRules: [
        v => !!v || 'Field is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
    }),

    mounted: function() {
      

     console.log('App mounted!');

     
    if (localStorage.getItem('jwsToken')) this.jwsToken = JSON.parse(localStorage.getItem('jwsToken'));

     this.username = store.state.userName;
     this.compName = store.state.companyName;



     this.GetStudentsAll();
     this.GetFilter();
     this.GetDemerits();


  },

    methods: {


    validateStudent:function() {

      this.studentArray = [];

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      axios.get('https://api.conciergepadedu.com/api/Rosters/GetValidate/' + this.studentId + "/" + this.studentDob + "/" + this.compName,auth).then(response => {

      if (response.data.error) {

        console.log("ERROR");
        this.validStudent = false;
        this.invalidStudent = true;
        this.studentExists = true;

      } else {

        console.log("SUCCESS");
        console.log(response.data);

        this.invalidStudent = false;
        this.studentExists = false;
        this.studentArray = response.data;

        }

        }).catch(error => {

            console.log(error.response);
            console.log("CATCH");
            this.validCode = false;
            this.invalidCode = true;
            this.studentExists = true;

        });

    },
  createPDF (demeritTitle,studentId,lastName,firstName,period,entryTime,userName,comments,printLabel) {
    let pdfName = 'electronic_slip_' + studentId + "_" + lastName + "_" + firstName; 
    var doc = new jsPDF();
    var newDate = moment().tz("America/New_York").format("YYYY-MM-DD");
    doc.text("Electronic Slip", 20, 20);
    doc.text("Printed: " + newDate,20, 30);
    doc.text("------------------------------------------------------------- ",10,40);

    doc.text(demeritTitle,20, 50);
    doc.text("------------------------------------------------------------- ",10,60);
    doc.text("STUDENT ID: " + studentId,20, 70);
    doc.text("LAST NAME: " + lastName,20, 90);
    doc.text("FIRST NAME: " + firstName,20, 110);
    doc.text("PERIOD: " + period,20, 130);
    doc.text("ENTRY TIME: " + entryTime.toString(),20, 150);
    doc.text("ISSUER: " + userName,20, 170);
    doc.text("COMMENTS: " + comments,20, 190);
    doc.text("*" + printLabel,20, 210);
    doc.save(pdfName + '.pdf');
  },
    clearDataTable: function() {

        this.hasData = false;
        this.studentSearchSelected = '';
        this.students = [];

    },

     tConvert: function (time) {
  // Check correct time format and split into components
  time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (time.length > 1) { // If time format correct
    time = time.slice (1);  // Remove full string match value
    time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  return time.join (''); // return adjusted time or original string
},

changeRoute(demeritObject) {
    //this.$router.push({path: a.src })
    console.log("In change route");

    //console.log(general);
    //console.log(code);


    console.log(demeritObject);

    this.demeritCodeSelected = '';
    this.generalValue = '';

    this.generalValue = demeritObject.general;
    this.demeritCodeSelected = demeritObject.code;

    if (typeof this.demeritCodeSelected === 'object') {

      console.log("AHHHHHHHHHHHHH I am an object")

      this.demeritCodeSelected = this.demeritObject.code;




    }



  },

    changeDate: function() {


      console.log("date changed");

      console.log(this.entryTime);

      console.log(this.tConvert (this.entryTime));

      this.entryTimeDisplay = this.tConvert (this.entryTime);

       console.log(this.entryDate.toString() + ' ' + this.entryTimeDisplay.toString())





    },

    updateAmPm: function() {


      console.log("ampm changed");

      console.log(this.entryTime);

      console.log(this.tConvert (this.entryTime));

      this.entryTimeDisplay = this.tConvert (this.entryTime);

       if (this.entryTimeDisplay.includes('AM')) {

           this.entryTimeDisplay = this.entryTimeDisplay.replace("AM", "PM");    

       } else if (this.entryTimeDisplay.includes('PM') ) {

         this.entryTimeDisplay = this.entryTimeDisplay.replace("PM", "AM");    

       }

       console.log(this.entryDate.toString() + ' ' + this.entryTimeDisplay.toString())



      //console.log(moment(this.entryTime).format("hh:mm a"));

      //this.entryTimeDisplay =  moment(this.entryTime).format("hh:mm")

      //this.entryTime = this.formatDate(this.entryTime);


    },

    processDemeritAlert: function() {


        if (this.studentIdSelected == '') {

            this.$alert("No Student selected","Student","error");

        } else if (this.duringPeriodSelected == '') {

            this.$alert("No Period selected","Period","error");

        } else if (this.demeritCodeSelected == '') {

            this.$alert("No Demerit selected","Demerit","error");

        } else if (this.comments.length >  500) {

            this.$alert("Please make your comments shorter","Comments","error");

        } else {

            this.$confirm("Are you sure you want to issue this demerit?").then(() => {

            this.processDemerit();


        });


        }

        


    },

    getCommentsCount: function() {

      console.log("This is change text");

      this.commentsCount = this.comments.length;

    },

    processDemerit:function() {


      

      console.log(this.studentIdSelected);
      console.log(this.duringPeriodSelected);
      console.log(this.demeritCodeSelected);

      if (this.comments.length == 0) {

          console.log("The comments is zero")

          this.comments = 'None';

      }

      this.schoolType = "NA"
      this.scanMethod = "MobileApp"

      this.comments = this.comments.replace('/','');
      this.comments = this.comments.replace('?', '');
      this.comments = this.comments.replace('#', '');
      this.comments = this.comments.replace('"', '');
      this.comments = this.comments.replace('[', '');
      this.comments = this.comments.replace(']', '');
      this.comments = this.comments.replace('@', '');
      this.comments = this.comments.replace(/(\r\n|\n|\r)/gm, "");
      this.comments = this.comments.replace('{', '');
      this.comments = this.comments.replace('}', '');
      this.comments = this.comments.replace('<', '');
      this.comments = this.comments.replace('>', '');
      this.comments = this.comments.replace('|', '');
      this.comments = this.comments.replace('`', '');
      this.comments = this.comments.replace(/[^a-zA-Z0-9-_]/g, ' ');
      //this.comments = this.comments.replace(/[|&;$%@"<>()+,]/g, "");
      this.comments = this.comments.replace('\t',' ');

      console.log("Entry Date: " + this.entryDate.toString());
      console.log("Entry Time: " + this.entryTimeDisplay.toString());
      console.log(this.schoolType)
      console.log(this.scanMethod)
      console.log(this.generalValue)

      this.uuid = uuid.v1();
      

      if (this.generalValue == null) {
        this.generalValue = "N";
      }

      if (this.generalValue == 'null') {
        this.generalValue = "N";
      }


      this.postDemerit(
        this.studentIdSelected,
        this.demeritCodeSelected,
        this.schoolType,
        this.duringPeriodSelected,
        this.scanMethod,
        this.comments,
        this.compName,
        this.username,
        this.uuid,
        this.entryDate.toString(),
        this.entryTimeDisplay.toString(),
        this.generalValue
        );

    },

    processDemeritGet:function() {

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };
      console.log(this.studentIdSelected);
      console.log(this.duringPeriodSelected);
      console.log(this.demeritCodeSelected);
     

   

      if (this.comments.length == 0) {

          console.log("The comments is zero")

          this.comments = 'None';

      }

      this.schoolType = "NA"
      this.scanMethod = "MobileApp"

      this.comments = this.comments.replace('/','');
      this.comments = this.comments.replace('?', '');
      this.comments = this.comments.replace('#', '');
      this.comments = this.comments.replace('"', '');
      this.comments = this.comments.replace('[', '');
      this.comments = this.comments.replace(']', '');
      this.comments = this.comments.replace('@', '');
      this.comments = this.comments.replace(/(\r\n|\n|\r)/gm, "");
      this.comments = this.comments.replace('{', '');
      this.comments = this.comments.replace('}', '');
      this.comments = this.comments.replace('<', '');
      this.comments = this.comments.replace('>', '');
      this.comments = this.comments.replace('|', '');
      this.comments = this.comments.replace('`', '');
      this.comments = this.comments.replace(/[^a-zA-Z0-9-_]/g, ' ');
      //this.comments = this.comments.replace(/[|&;$%@"<>()+,]/g, "");
      this.comments = this.comments.replace('\t',' ');






      console.log("Entry Date: " + this.entryDate.toString());
      console.log("Entry Time: " + this.entryTimeDisplay.toString());
      console.log(this.schoolType)
      console.log(this.scanMethod)
      console.log(this.generalValue)
      console.log("https://api.conciergepadedu.com/api/Slips/GetProcessDemerit/" + this.studentIdSelected + "/" + this.demeritCodeSelected + "/" + this.schoolType + "/" + this.duringPeriodSelected + "/" + this.scanMethod + "/" + this.comments + "/" + this.compName + "/" + this.username + "/" + this.uuid  + "/" + this.entryDate.toString()  + "/" + this.entryTimeDisplay.toString() + "/" + this.generalValue)
     

      this.uuid = uuid.v1();

     


      axios.get('https://api.conciergepadedu.com/api/Slips/GetProcessDemerit/' + this.studentIdSelected + "/" + this.demeritCodeSelected + "/" + this.schoolType + "/" + this.duringPeriodSelected + "/" + this.scanMethod + "/" + this.comments + "/" + this.compName + "/" + this.username + "/" + this.uuid  + "/" + this.entryDate.toString()  + "/" + this.entryTimeDisplay.toString() + "/" + this.generalValue,auth).then(response => {

      if (response.data.error) {

        console.log("ERROR");
        this.$alert("Demerit NOT Issued Successfully","Error","error");


      } else {

        console.log("SUCCESS");
        console.log(response.data);

        this.students = response.data;

       this.studentIdSelected = '';
       this.duringPeriodSelected = '';
       this.demeritCodeSelected = '';
       this.comments = '';

       this.$alert("Demerit Issued Successfully","Demerit","success");




        }

        }).catch(error => {

            console.log(error.response);
            console.log("CATCH");
            this.$alert("Demerit NOT Issued Successfully","Error","error");


        });

    },

    GetDemerits:function() {

      this.demeritCodeArray = [];

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      axios.get('https://api.conciergepadedu.com/api/Demerits/DemeritInfo/' + this.compName,auth).then(response => {

      if (response.data.error) {

        console.log(response.data.error);

      } else {

        console.log("SUCCESS");
        console.log(response.data);
        this.demeritCodeArray = response.data;

         console.log("About to do loop");
          console.log(this.demeritCodeArray);

        for (var i = 0; i < this.demeritCodeArray.length; i++) {

          console.log("Demerit Code: " + this.demeritCodeArray[i].demeriT_CODE);
                let newObject = {
                        code: this.demeritCodeArray[i].demeriT_CODE,
                        desc: this.demeritCodeArray[i].demeriT_DESC,
                        general: this.demeritCodeArray[i].generaL_VALUE
                    }

                this.demeritCodes.push(newObject);

            }


        }

        }).catch(error => {

            console.log(error.response);
            console.log("CATCH");
            


        });

    },


    StudentProfileAlert: function() {


        if (this.studentSearchSelected == '') {

            this.$alert("No Student selected","Student","error");

        } else {


            this.GetStudentProfile();


        }

        


    },

    GetStudentProfile:function() {

      this.loaded = true;

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      axios.get('https://api.conciergepadedu.com/api/Slips/GetStudentProfile/' + this.studentSearchSelected + "/" + this.compName,auth).then(response => {

      if (response.data.error) {

        console.log("ERROR");
        this.$alert("Could not lookup Student","Error","error");
        this.studentSearchSelected = '';
        this.loaded = false;
        this.hasData = false;


      } else {

        console.log("SUCCESS");
        console.log(response.data);

        this.students = response.data;

        this.loaded = false;

        this.hasData = true;

       //this.studentSearchSelected = '';




        }

        }).catch(error => {

            this.studentSearchSelected = '';
            this.hasData = false;
            console.log(error.response);
            console.log("CATCH");
            this.$alert("Could not lookup Student","Catch","error");
            this.loaded = false;


        });

    },


    GetStudentProfileDemerit:function(code) {

      console.log(this.studentSearchSelected);
      console.log(this.compName)
      console.log(code);
     

      this.loaded = true;

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

 

      axios.get('https://api.conciergepadedu.com/api/Slips/GetStudentProfileDemerit/' + this.studentSearchSelected + "/" + this.compName + "/" + code,auth).then(response => {

      if (response.data.error) {

        console.log("ERROR");
        this.$alert("Could not lookup Student","Error","error");
        this.studentSearchSelected = '';
        this.loaded = false;


      } else {

        console.log("SUCCESS");
        console.log(response.data);

        this.students = response.data;

        this.loaded = false;

       //this.studentSearchSelected = '';




        }

        }).catch(error => {

            this.studentSearchSelected = '';
            console.log(error.response);
            console.log("CATCH");
            this.$alert("Could not lookup Student","Catch","error");
            this.loaded = false;


        });

    },

    GetStudentsAll:function() {

      this.loaded = true;
      //this.studentsAllArrayTemp = []; 
      //this.studentsAllArray = [];

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      axios.get('https://api.conciergepadedu.com/api/Rosters/GetStudentsAll/' + this.compName,auth).then(response => {

      if (response.data.error) {

        console.log("ERROR");

        this.loaded = false;


      } else {

        console.log("SUCCESS");
        console.log(response.data);

        this.studentsAllArrayTemp = response.data;

            for (var i = 0; i < this.studentsAllArrayTemp.length; i++) {

                let newObject = {
                        name: this.studentsAllArrayTemp[i].firsT_NAME + ' ' + this.studentsAllArrayTemp[i].lasT_NAME + ' - Grade: ' + this.studentsAllArrayTemp[i].grade + ' - DOB: ' +  moment(String(this.studentsAllArrayTemp[i].birthday)).format('MM/DD/YYYY'),
                        studentId: this.studentsAllArrayTemp[i].studenT_ID
                    }

                this.studentsAllArray.push(newObject);

            }

            this.loaded = false;
            console.log("Here is the Array: " + this.studentsAllArray);


        }

        }).catch(error => {

            this.loaded = false;
            console.log(error.response);
            console.log("CATCH IN THE STUDENT SECTION");

        });

    },

    formatDate(value) {
      return moment(value).format("MM/DD/YY hh:mm a")
    },

    simpleDate(value) {
      return moment(value).format("MM/DD/YY")
    },

    GetFilter:function() {

      this.loaded = true;
      this.duringPeriodTemp = []; 
      this.duringPeriod = [];

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      axios.get('https://api.conciergepadedu.com/api/Filters/GetFilter/' + this.compName,auth).then(response => {

      if (response.data.error) {

        console.log("ERROR");

        this.loaded = false;


      } else {

        console.log("SUCCESS");
        console.log(response.data);

        this.duringPeriodTemp = response.data;

            for (var i = 0; i < this.duringPeriodTemp.length; i++) {


                this.duringPeriod.push(this.duringPeriodTemp[i].filteR_LABEL);

            }

            this.loaded = false;
            console.log("Here is the Array: " + this.duringPeriod);


        }

        }).catch(error => {

            this.loaded = false;
            console.log(error.response);
            console.log("CATCH IN THE STUDENT SECTION");

        });

    },


    rowClick: function (item, row) {      
      row.select(true);
      console.log(item);
      //item  - selected item
    },
    selectStudent(myItem) {

      console.log(myItem);

    },
    uppercase() {
        

        if (this.studentId.length > 0 && this.studentDob.length > 9) {

          console.log("In the validate student")

          this.validateStudent();

        } else {

          //this.invalidStudent = true;
          //this.validStudent = false;
        }
  },

  addStudent() {

    console.log(this.loginUuid);
    console.log(this.studentArray.studenT_ID);
    console.log(this.studentArray.companY_NAME);
    console.log(this.studentArray.firsT_NAME);

     var newDate = moment().tz("America/New_York").format("YYYY-MM-DD HH:mm:ss.SSS");

    this.postStudent(
      this.studentArray.studenT_ID,
      this.studentArray.companY_NAME,
      newDate,
      this.loginUuid,
      this.studentArray.firsT_NAME,
      this.studentArray.lasT_NAME,
      this.studentArray.householD_ID,
      this.studentArray.hangeR_ID,
      this.studentArray.grade,
      this.studentArray.homeroom,
      this.studentArray.birthday,
      newDate)

  },
//{STUDENT_ID}/{DEMERIT_CODE}/{SCHOOL_TYPE}/{DURING_PERIOD}/{SCAN_METHOD}/{COMMENTS}/{COMPANY_NAME}/{USERNAME}/{TRIGGER_LINK}/{API_ENTRY_DATE}/{API_ENTRY_TIME}/{GENERAL_VALUE}
  postDemerit(studentId,demeritCode,schoolType,duringPeriod,scanMethod,comments,companyName,userName,triggerLink,apiEntryDate,apiEntryTime,generalValue) {

  console.log("IN THE POST YO ******************************");

  console.log("studentId: " + studentId);
  console.log("demeritCode: " + demeritCode);
  console.log("schoolType: " + schoolType);
  console.log("duringPeriod: " + duringPeriod);
  console.log("scanMethod: " + scanMethod);
  console.log("comments: " + comments);
  console.log("companyName: " + companyName);
  console.log("userName: " + userName);
  console.log("triggerLink: " + triggerLink);
  console.log("apiEntryDate: " + apiEntryDate);
  console.log("apiEntryTime: " + apiEntryTime);
  console.log("generalValue: " + generalValue);

  const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
  };

  axios.post('https://api.conciergepadedu.com/api/Slips/PostDemerit',{ 
            STUDENT_ID: studentId,
            DEMERIT_CODE: demeritCode,
            SCHOOL_TYPE: schoolType,
            DURING_PERIOD: duringPeriod,
            SCAN_METHOD: scanMethod,
            COMMENTS: comments,
            COMPANY_NAME: companyName,
            USERNAME: userName,
            TRIGGER_LINK: triggerLink,
            API_ENTRY_DATE: apiEntryDate,
            API_ENTRY_TIME: apiEntryTime,
            GENERAL_VALUE: generalValue

      },auth).then(response => {


      if (response.data.error) {

        console.log("ERROR");
        console.log(response.data.error);
        this.$alert("Demerit NOT Issued Successfully","Error","error");


      } else {

        console.log("SUCCESS");
        console.log(response.data);

        this.students = response.data;

        this.studentIdSelected = '';
        this.duringPeriodSelected = '';
        this.demeritCodeSelected = '';
        this.comments = '';

        this.$alert("Demerit Issued Successfully","Demerit","success");

      } 

        }).catch(error => {

            console.log(error.response);
            console.log("CATCH");
            this.$alert("Demerit NOT Issued Successfully","Error","error");


        });

 

  },

  postStudent(studentId,companyName,dateAdded,logUuid,firstName,lastName,householdId,hangerId,grade,homeRoom,dob,removeDate) {

    const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
  };

  axios.post('https://api.conciergepadedu.com/api/Apps/StudentAdd',{ 
            STUDENT_ID: studentId,
            COMPANY_NAME: companyName,
            DATE_ADDED: dateAdded,
            LOGIN_UUID: logUuid,
            ACTIVE_FLAG: 'Y',
            FIRST_NAME: firstName,
            LAST_NAME: lastName,
            HOUSEHOLD_ID: householdId,
            HANGER_ID: hangerId,
            GRADE: grade,
            HOMEROOM: homeRoom,
            BIRTHDAY: dob,
            REMOVE_DATE: removeDate

      },auth).then(response => {


      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error);

          this.validStudent = false;
          this.invalidStudent = true;


      } else {

      console.log('success', response.data);
      this.validStudent = false;
      this.invalidStudent = false;

      this.addStudentArray = response.data;

      var hangerIdCheck = this.addStudentArray.householD_ID;

      this.getHangerId(this.studentId,hangerIdCheck,this.compName);


      if (hangerIdCheck !== '') {

        console.log("Student Added Successfully","Add","success");

      } else {

        console.log("No Household ID detected");

        //this.$alert("No Household ID detected","Add","error");
        
      }
   

   
      
      
      } 

  

        }).catch(error => {

            console.log(error.response);

              this.validStudent = false;
              this.invalidStudent = true;


        });

 

  },




 


removeStudent(pId,studentId,firstName,lastName,entryTime,schoolType,demeritCode,comments,companyName,entryDate,demeritDesc,userName,removalFlag,scanMethod,duringPeriod,triggerLink) {

  if (this.studentSearchSelected.length == 0) {

    this.$alert("Lookup Student textbox is empty in toolbar above","Search","error");

  } else {

    //this.removeStudentApi(pId,studentId,firstName,lastName,entryTime,schoolType,demeritCode,comments,companyName,entryDate,demeritDesc,userName,removalFlag,scanMethod,duringPeriod,triggerLink);
 this.$confirm("Are you sure you want to remove?").then(() => {
    this.deleteDemerit(companyName,studentId,triggerLink,userName);
 });
    
  }

},
 
  removeStudentApi(pId,studentId,firstName,lastName,entryTime,schoolType,demeritCode,comments,companyName,entryDate,demeritDesc,userName,removalFlag,scanMethod,duringPeriod,triggerLink) {

    console.log(pId);

    var newDate = moment().tz("America/New_York").format("YYYY-MM-DD HH:mm:ss.SSS");

    console.log(newDate);

  this.$confirm("Are you sure?").then(() => {
  //do something...

 

  const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
  };

  axios.put('https://api.conciergepadedu.com/api/Slips/RemoveRecord/' + String(pId),{ 
         ID: pId,
         STUDENT_ID: studentId,
         FIRST_NAME: firstName,
         LAST_NAME: lastName,
         ENTRY_TIME: entryTime,
         SCHOOL_TYPE: schoolType,
         DEMERIT_CODE: demeritCode,
         COMMENTS: comments,
         COMPANY_NAME: companyName,
         ENTRY_DATE: entryDate,
         DEMERIT_DESC: demeritDesc,
         USERNAME: userName,
         REMOVAL_FLAG: removalFlag,
         SCAN_METHOD: scanMethod,
         DURING_PERIOD: duringPeriod,
         TRIGGER_LINK: triggerLink
      },auth).then(response => {


      if (response.data.error) {

          console.log("ERROR");
          console.log('error', response.data.error);



      } else {

      console.log('success', response.data);

      this.GetStudentProfile();

      this.$alert("Demerit Removed Successfully","Remove","success");

      } 

  

        }).catch(error => {

            console.log("CATCH");
            console.log(error.response);




        });

  });

  

   



    },

    updateUserButton(index) {

        console.log(this.items[index].firsT_NAME);
        console.log(this.items[index].lasT_NAME);

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };



  axios.put('https://api.conciergepadedu.com/api/Users/PutPush/' + String(this.items[index].id),{ 
         ID: this.items[index].id,
         USERNAME: this.items[index].username,
         PASSWORD:  this.items[index].password,
         COMPANY_NAME: this.items[index].companY_NAME,
         UUID: this.items[index].uuid,
         MOBILE_PHONE:  this.items[index].mobilE_PHONE,
         FIRST_NAME: this.items[index].firsT_NAME,
         LAST_NAME:this.items[index].lasT_NAME,
         EMAIL: this.items[index].username,
         DOB: this.items[index].dob,
         DATE_CREATED: this.items[index].datE_CREATED,
         HANGER_ID: this.items[index].hangeR_ID,
         PUSH_TOKEN: this.items[index].pusH_TOKEN
      },auth).then(response => {


      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error);

          this.validUpdate = false;
          this.invalidUpdate = true;

      } else {

      console.log('success', response.data);
      this.validUpdate = true;
      this.invalidUpdate = false;
      this.getAuthParents();
      this.sendEmail(this.items[index].username);
      
      } 

  

        }).catch(error => {

            console.log(error.response);

              this.validUpdate = false;
              this.invalidUpdate = true;




        });



    },

  uploadParentToApi(firstName,lastName,dob,companyName,studentId,studentRelation,hangerId, authEmail) {

  axios.post('https://api.conciergepadedu.com/api/Parents/PostParent',{ 
         FIRST_NAME: firstName,
         LAST_NAME: lastName,
         DOB: dob,
         COMPANY_NAME: companyName,
         AUTH_TYPE: 'Y',
         STUDENT_ID: studentId,
         DATE_ADDED: new Date(),
         STUDENT_RELATION: studentRelation,
         HANGER_ID: hangerId,
         AUTH_EMAIL: authEmail
      }).then(response => {


      if (response.data.error) {

        console.log('error', response.data.error)

      } else {

        console.log('success', response.data)
      }

     }).catch(error => {

        console.log(error.response)

      });

   
    },

    deleteDemerit(companyName,studentId,triggerLink,userName) {

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      console.log("Bearer " + this.jwsToken)

      axios.get('https://api.conciergepadedu.com/api/Slips/DeleteDemerit/' +  companyName + '/' + studentId + "/" + triggerLink + "/" + userName ,auth).then(response => {


   

      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error)

 

      } else {

        console.log("**********************************")

        console.log(response.data);

        if (response.data == "200") {

          this.$alert("Demerit Removed Successfully","Remove","success");

          this.GetStudentProfile();

        } else {

          this.$alert("Not Removed Successfully","Remove","error");
        }
       






        }



        }).catch(error => {

            console.log(error.response)




        });

    },
    sendEmail:function(email) {

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      console.log("Bearer " + this.jwsToken)

      axios.get('https://api.conciergepadedu.com/api/Users/SendEmail/' + email,auth).then(response => {


   

      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error)

 

      } else {

        console.log("**********************************")

        console.log(response.data);


        }



        }).catch(error => {

            console.log(error.response)




        });

    },

    getAuthParents:function() {

    


      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      console.log("Bearer " + this.jwsToken)

      axios.get('https://api.conciergepadedu.com/api/Users/GetAuth/' +  this.hangerId + '/' + this.compName,auth).then(response => {


   

      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error)

 

      } else {

        console.log("**********************************")

        console.log(response.data);


        this.items = response.data;
        this.firstName = this.items.firsT_NAME;






        }



        }).catch(error => {

            console.log(error.response)




        });

    },
   
    getStudents:function() {

      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      axios.get('https://api.conciergepadedu.com/api/Apps/GetLoginUUID/' +  this.loginUuid + '/' + this.compName,auth).then(response => {

      if (response.data.error) {

          console.log("ERROR")
          console.log('error', response.data.error)

 

      } else {

        console.log("**********************************")

        console.log(response.data);


        this.students = response.data;

        }



        }).catch(error => {

            console.log(error.response)


        });

    },
    getHangerId:function(studentId, householdId, companyName) {
      this.hangerIdArray = [];
      const auth = {
        headers: {Authorization: "Bearer " + this.jwsToken} 
      };

      axios.get('https://api.conciergepadedu.com/api/Hangers/' +  studentId + '/' + householdId + "/" + companyName,auth).then(response => {

      if (response.data.error) {

          console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
          console.log('error', response.data.error)

          this.studentId = '';
          this.studentDob = '';

          this.$alert("No Household ID Found, please contact school for more information. (error)","Add","error");

         

      } else {

        console.log(">>>>>>>SUCCESS>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");

        console.log(response.data);
        this.hangerIdArray = response.data;

     

        if (this.hangerIdArray) {

         this.getStudents();
         
         this.$alert("Student Added Successfully","Add","success");


         } else {

         this.$alert("No Household ID Found, please contact school for more information. (not found)","Add","error");

         }

        this.studentId = '';
        this.studentDob = '';
         

        }



        }).catch(error => {
          
            console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
            console.log(error.response)
            this.studentId = '';
            this.studentDob = '';
            this.$alert("No Household ID Found, please contact school for more information. (catch)","No Add","error")


        });

    },
    checkEmailGuardian() {

       if (this.guardianEmail == this.email) {

         this.validEmailGuardian = false;
         this.invalidEmailGuardian = true;
         this.alreadyRegistered = "Already registered as Guardian.  Don't have to input yourself."

       } else {

        this.validEmailGuardian = true;
        this.invalidEmailGuardian = false;
        this.alreadyRegistered = ""

        this.checkGuardian();

       }


    },
    checkGuardian:function() {

      axios.get('https://api.conciergepadedu.com/api/Users/CheckUser/' +  this.guardianEmail).then(response => {

      if (response.data.error) {

         console.log("ERROR");

        this.validEmailGuardian = true;
        this.invalidEmailGuardian = false;
        this.alreadyRegistered = "Email not registered"

      } else {

        console.log(response.data);

        //successful
        this.validEmailGuardian = false;
        this.invalidEmailGuardian = true;
        this.alreadyRegistered = "Email already registered"

        }

        }).catch(error => {

            console.log(error.response)

            this.validEmailGuardian = true;
            this.invalidEmailGuardian = false;
            this.alreadyRegistered = "Email not registered"

            if (this.guardianEmail.length == 0) {

            this.validEmailGuardian = false;
            this.invalidEmailGuardian = false;
            this.alreadyRegistered = "";

            }

        });

    },

      validate () {
        this.$refs.form.validate()
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
    },
  }
</script>